import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';
import GrillaEffect from 'views/Grillas/GrillaEffect';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import DataLabel from 'views/Cards/DataLabel';

function RecursosHumanos() {
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const GenerarPdf = async () => {
    try {
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/21`;
      const rest = await fetch(baseURL, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token'),
        },
        body: JSON.stringify({
          fdesde: new Date(startDate).toLocaleDateString(),
          fhasta: new Date(endDate).toLocaleDateString()
        })
      });
      const resulte = await rest.json();
      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      const doc = new jsPDF();
      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: 'left',
          valign: 'center',
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');
    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }
  };

  const defaultFecha = [
    { id: 'periodo', value: '202403' }
  ];
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState([...defaultFecha]);
  const url = `${process.env.REACT_APP_API_URL}/querysextgrilla/`;

  const columnNames = {
    legajo: 'Legajo',
    dni: 'DNI',
    apellido_nombre: 'Nombre Completo',
    convenio: 'Convenio',
    inasistencias: 'Inasistencias',
    importe_neto: 'Neto',
    importe_ganancias: 'Ganancias',
  };

  const topToolbar = function (table) {
    return <Box>
      <TextField
        label="Desde"
        value={filters.find(i => i.id == 'periodo').value}
        onChange={(fecha) => {
          let items = [...filters];
          const x = items.findIndex(i => i.id == 'periodo');
          let item = { ...items[x], value: fecha };
          items[x] = item;
          table.table.setColumnFilters(items);
        }}
      />
    </Box>;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: '120px' }}>
      <Card>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Card sx={{ minHeight: 125 }}>
                <CardBody>
                  <Grid container spacing={1}>
                  </Grid>
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ minHeight: 125 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', mb: 3 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: '13px', fontWeight: 'bold' }}
                      onClick={GenerarCsv}
                    >
                      Exportar CSV
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: '13px', fontWeight: 'bold', ml: 1 }}
                      onClick={GenerarPdf}
                    >
                      Exportar PDF
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>
          <Card sx={{ p: 2, my: 1 }}>
            <CardBody>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <GrillaEffect
                  data={data} updateData={setData}
                  filters={filters} updateFilters={setFilters}
                  colsHeaders={columnNames}
                  idRemoto={42} />
              </LocalizationProvider>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Box>
  );
}

export default RecursosHumanos;
